import { Injectable } from "@angular/core";
import { TransactionHistoryAction } from "@edp-models/transactions-history.model";
import { UserLevelRequest } from "@edp-models/user-level.model";
import { LevelsService } from "@edp-services/levels.service";
import { ELevelsActions, LoadUserLevel } from "@edp-store/actions/levels.actions";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { EMPTY } from "rxjs";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";

@Injectable()
export class LevelsEffects {

    getHistory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ELevelsActions.GetHistory),
            switchMap((args: TransactionHistoryAction) =>
                this.levelsService.getHistory(args.payload).pipe(
                    map(response => {
                        return { type: ELevelsActions.SaveHistory, payload: response };
                    }),
                    catchError(() => EMPTY)
                )
            )
        )
    );

    constructor(private actions$: Actions, private levelsService: LevelsService) {}
}
